/**
 * Paylaşılan bileşenlerin metinleri (08 §6, §6.1; S09): telefon, kod ve PIN girişi, adım göstergesi, tablo,
 * sayfalama, filtre çubuğu, toplu işlem çubuğu, kişi seçici ve bağlantı şeridi. Hitap "siz"dir (08 §9.2).
 */
export const components = {
  phone: {
    placeholder: '5xx xxx xx xx',
    invalid: 'Cep telefonu numarası 10 haneli olmalı ve 5 ile başlamalı (5xx xxx xx xx).',
  },
  otp: {
    label: 'Doğrulama kodu',
    hint: '{length} haneli kodu yazın ya da yapıştırın.',
    invalidLength: 'Kod {length} haneli olmalı.',
    resendIn: 'Yeni kodu {seconds} sn sonra isteyebilirsiniz.',
    resend: 'Kodu yeniden gönder',
  },
  pin: {
    progress: '{count}/{length} hane girildi',
    deleteDigit: 'Son haneyi sil',
    keypad: 'PIN tuş takımı',
  },
  stepper: {
    label: 'İlerleme',
    progress: 'Adım {current}/{total}',
    state: {
      complete: 'tamamlandı',
      current: 'şu anki adım',
      upcoming: 'sırada',
      error: 'hatalı',
      skipped: 'atlandı',
    },
  },
  table: {
    loading: 'Kayıtlar yükleniyor…',
    refreshing: 'Liste güncelleniyor…',
    region: '{caption} tablosu',
    sortBy: '{column} sütununa göre sırala',
    selectRow: 'Satırı seç',
    selectPage: 'Bu sayfadaki bütün satırları seç',
    pageSelected: 'Bu sayfadaki {count} kayıt seçili.',
    selectAllPages: 'Tüm sayfaları seç ({count} kayıt)',
    allPagesSelected: 'Tüm sayfalardaki {count} kayıt seçili.',
    clearSelection: 'Seçimi kaldır',
    columns: 'Sütunlar',
  },
  pagination: {
    label: 'Sayfalama',
    previous: 'Önceki sayfa',
    next: 'Sonraki sayfa',
    page: 'Sayfa {page}/{pages}',
    pageSize: 'Sayfa başına kayıt',
  },
  filters: {
    search: 'Ara',
    active: '{count} filtre etkin',
    open: 'Filtreler',
    openWithCount: 'Filtreler ({count})',
    apply: 'Sonuçları göster',
    remove: '{label} filtresini kaldır',
    any: 'Tümü',
    yes: 'Evet',
    no: 'Hayır',
    from: 'Başlangıç',
    to: 'Bitiş',
    min: 'En az',
    max: 'En çok',
    selectedCount: '{count} seçili',
  },
  bulk: {
    region: 'Toplu işlemler',
    selected: '{count} kayıt seçili',
    clear: 'Seçimi kaldır',
  },
  // Ayarların kaydet çubuğu ve dosya yükleme (S15; 08 §6 #56, #59).
  unsavedChanges: {
    region: 'Kaydedilmemiş değişiklikler',
    count: 'Kaydedilmemiş {count} değişiklik',
  },
  fileUpload: {
    drop: 'Dosyayı buraya sürükleyin ya da',
    dropActive: 'Dosyayı bırakın',
    choose: 'Dosya seç',
    replace: 'Başka dosya seç',
    remove: 'Kaldır',
    removeLabel: '{name} dosyasını kaldır',
    hint: '{types} · en çok {size}',
    uploading: 'Yükleniyor…',
    uploadingPercent: 'Yükleniyor: yüzde {percent}',
    typeError: 'Bu dosya türü yüklenemez. {types} dosyası seçin.',
    sizeError: 'Dosya çok büyük ({size}). En çok {max} olabilir.',
    emptyError: 'Dosya boş. Başka bir dosya seçin.',
    bytes: '{value} bayt',
    kilobytes: '{value} KB',
    megabytes: '{value} MB',
  },
  picker: {
    searchPlaceholder: 'Ad, sicil ya da telefonla arayın',
    typeToSearch: 'Aramak için en az iki harf yazın.',
    searching: 'Aranıyor…',
    noResults: '"{query}" için sonuç yok.',
    outOfScope: 'Bu kişi yetki kapsamınızda değil.',
    recent: 'Son seçilenler',
    results: 'Sonuçlar',
    resultCount: '{count} sonuç',
    loadingMore: 'Daha fazla sonuç yükleniyor…',
    remove: '{name} seçimini kaldır',
    selectedCount: '{count} kişi seçili',
    addGroup: '{group} tamamını ekle',
  },
  network: {
    offline: 'Bağlantı yok. Bağlantı gelince sayfa kendiliğinden güncellenir.',
    backOnline: 'Bağlantı yeniden kuruldu.',
  },
  tabBar: {
    label: 'Çalışan menüsü',
    badge: '{count} bekleyen',
  },
  timeline: {
    corrected: 'Düzeltildi',
    previous: 'Önceki saat {time}',
    current: 'Şu anki adım',
  },
  time: {
    placeholder: 'SS:DD',
    invalid: 'Saati 24 saat biçiminde yazın (ör. 07:30).',
    overnight: '+1 gün',
    overnightLabel: 'Ertesi gün {time}',
    start: 'Başlangıç',
    end: 'Bitiş',
    endBeforeStart: 'Bitiş saati başlangıçtan sonra olmalı.',
  },
  dateRange: {
    placeholder: 'Tarih aralığı seçin',
    presets: 'Hazır aralıklar',
    today: 'Bugün',
    yesterday: 'Dün',
    thisWeek: 'Bu hafta',
    lastWeek: 'Geçen hafta',
    thisMonth: 'Bu ay',
    lastMonth: 'Geçen ay',
    last7: 'Son 7 gün',
    last30: 'Son 30 gün',
    from: 'Başlangıç',
    to: 'Bitiş',
    format: 'GG.AA.YYYY',
    invalidDate: 'Tarihi GG.AA.YYYY biçiminde yazın (ör. 03.09.2026).',
    order: 'Bitiş tarihi başlangıçtan önce olamaz.',
    apply: 'Uygula',
    clear: 'Temizle',
    calendar: 'Takvim',
    previousMonth: 'Önceki ay',
    nextMonth: 'Sonraki ay',
    navigation: 'Ay gezinmesi',
    todayMarker: 'bugün',
    selected: 'seçili',
    summary: '{from} – {to}',
  },
  scanner: {
    region: 'QR tarayıcı',
    hint: "Kapıdaki ekranın QR'ını çerçeveye getirin.",
    starting: 'Kamera açılıyor…',
    torchOn: 'Işığı aç',
    torchOff: 'Işığı kapat',
  },
  statCard: {
    loading: '{label} yükleniyor',
    help: '{label}: nasıl hesaplanır?',
    up: '{delta} artış',
    down: '{delta} azalış',
    flat: 'Değişiklik yok',
  },
  chart: {
    showTable: 'Veri tablosu olarak göster',
    showChart: 'Grafik olarak göster',
    summary: '{title}: {count} dönem; en yüksek {max}',
    total: 'Toplam',
  },
  approvalCard: {
    requestedBy: 'Talep eden',
    subject: 'Kişi',
    requestedAt: 'Açılış',
    due: 'Son tarih {date}',
    overdue: 'Süresi doldu',
    selfApproval: 'Öz-onay',
    step: 'Adım {current}/{total}',
  },
  readOnly: {
    notice: 'Telefonda salt okunur. Düzenlemek için bilgisayardan açın.',
  },
  // Puantaj bileşenleri (S15; 08 §6 #25, #26, #40, #42): gün hücresinin tam cümle etiketi, cetvel, ay seçici, takvim.
  dayCell: {
    empty: 'kayıt yok',
    future: 'henüz gelmedi',
    worked: '{duration} çalıştı',
    restDay: 'hafta sonu',
    holiday: 'resmi tatil: {name}',
    selected: 'gün detayı açık',
  },
  timesheetGrid: {
    employee: 'Çalışan',
    today: 'bugün',
    problemRow: 'Sorunlu gün var',
  },
  /** Vardiya çizelgesi (08 §6 #41, §6.1 RosterGrid; S22-a). */
  rosterGrid: {
    employee: 'Çalışan',
    today: 'bugün',
    holiday: 'resmî tatil: {name}',
    halfHoliday: 'resmî tatil, 13:00\'ten sonra: {name}',
    group: '{name} ({count})',
    palette: 'Palet',
    paletteHint: 'Hücreleri seçin, sonra çipe basın ya da çipi hücreye sürükleyin.',
    paletteApply: '{visible}: seçili hücrelere uygula ({label})',
    dragInstructions: 'Çipi bir hücreye sürükleyip bırakın. Sürüklemeden: hücreleri seçin ve çipe basın.',
    dragStart: '{label} sürükleniyor.',
    dragOver: '{label} bir hücrenin üzerinde.',
    dragEnd: '{label} bırakıldı.',
    dragCancel: 'Sürükleme iptal edildi.',
    shortcuts: 'Klavye kısayolları',
    keys: {
      move: 'Hücreler arasında gezin',
      extend: 'Seçimi genişletin',
      type: 'Şablon kodunu yazarak atayın',
      clear: 'Seçili hücreleri temizleyin',
      copy: 'Kopyalayın',
      paste: 'Yapıştırın',
      undo: 'Geri alın',
      redo: 'Yineleyin',
      open: 'Hücre panelini açın',
      escape: 'Seçimi kaldırın',
    },
    applied: '{count} hücreye {label} uygulandı.',
    cleared: '{count} hücre temizlendi.',
    copied: '{count} hücre kopyalandı.',
    pasted: '{count} hücreye yapıştırıldı.',
    nothingCopied: 'Yapıştırmadan önce hücre kopyalayın.',
    selectFirst: 'Önce bir ya da daha çok hücre seçin.',
    readOnly: 'Seçili hücreler değiştirilemez.',
    noCode: '"{code}" kodlu şablon yok.',
    selection: '{count} hücre seçili',
    selectionEmpty: 'Hücre seçili değil',
    editCell: 'Hücreyi düzenle',
  },
  monthPicker: {
    label: 'Ay',
    previous: 'Önceki ay',
    next: 'Sonraki ay',
    choose: 'Ay seçin',
    previousYear: 'Önceki yıl',
    nextYear: 'Sonraki yıl',
  },
  legend: {
    label: 'Kodların anlamı',
  },
} as const;
